import axios from 'axios';
import config from '../config';

export interface OnboardDevicesOnlineStatusWsTicket {
    ws_token: string;
    expires_in: number;
    expires_at: string;
}

export const createOnboardDevicesOnlineStatusWsTicket = (): Promise<OnboardDevicesOnlineStatusWsTicket> => {
    return axios.post(`${config.API_URL}/onboard-devices/peers/online/ws-ticket`).then((response: any) => {
        return response.data?.data || response.data;
    });
};
